// extracted by mini-css-extract-plugin
module.exports = {"apple-pay-section-bag":"styles_apple-pay-section-bag__teLr4","or":"styles_or___VWxf"};